import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import LayoutPanel from 'components/layout/layoutPanel';
import ProductSelect from '../common/ProductSelect';
import ProductSelectSummer from '../common/ProductSelectSummer';
import { LinkModal } from 'kh-common-components';

import { modalContents } from '../../constants/modal-content';
import { useSummerCampaignActive } from '../../constants/hooks/marketingEventToggles';

function ProductsInfo (props) {
    const [plansData, setPlansData] = useState(null);

    const getPlanData = async () => {

        if (plansData !== null) {
            return;
        }

        try {
            const plans = await Axios.get(process.env.PRODUCTS_API);
            const reversed = plans.data.reverse();
            setPlansData(reversed);
        } catch (error) {
            console.log('Error getting plan details');
        }
    };

    useEffect(() => {
        getPlanData();
    });

    const isSummerCampaignActive = useSummerCampaignActive();

    return (
        <>
        {Array.isArray(plansData) && plansData.length > 0 &&
        <>            
            <LayoutPanel background={props.panelBackground}
                         padding={props.panelPadding}
                         theme={props.panelTheme}>
                
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 content text-center mb-4">
                            <h2>{props.panelHeading ? props.panelHeading : 'Natural gas pricing'}</h2>
                        </div>
                    </div>
                </div>
            {isSummerCampaignActive && 
                <ProductSelectSummer 
                    equalHeight={true}
                    data={plansData}
                />
            }    
            {!isSummerCampaignActive && 
                <ProductSelect 
                    equalHeight={true}
                    data={plansData}
                />
            }      
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 text-center">
                            <div>                  
                                <small><LinkModal {...props}
                                    modalContents={modalContents}
                                    useModal="true"
                                    title="Prices and fees for all natural gas customers"
                                    // linkClass=""
                                    displayContent="View prices and fees for all natural gas customers"
                                    modalTitle="Prices and fees for all natural gas customers"
                                    modalContentName="standard_prices_and_fees"
                                    okayButtonLabel="Okay"
                                /></small>
                            </div>
                        </div>
                    </div>
                </div>
            {isSummerCampaignActive && 
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 text-center pt-0">
                            <p className="mer-color--primary-blue mer-font--weight-bolder mt-sm-2 mer-typography--headline5"><sup>^</sup>Offer available online only to new and moving customers. Offer ends 30 May 2025.</p>
                            <p><small><LinkModal {...props}
                                modalContents={modalContents}
                                useModal="true"
                                title="Welcome bonus terms and conditions"
                                // linkClass=""
                                displayContent={<span><sup>+</sup>Welcome bonus terms and conditions.</span>}
                                modalTitle="Welcome bonus terms and conditions"
                                modalContentName="summer-terms"
                                okayButtonLabel="Okay"
                            /></small></p>
                        </div>
                    </div>
                </div>
            } 
            </LayoutPanel>
        </>
        }</>
    )
}

export default ProductsInfo;